import { useStatusToastContext } from './StatusToastContext';

export const useStatusToast = () => {
	const { addToast, removeToast, toasts } = useStatusToastContext();
	return { 
		showToast: addToast,
		removeToast,
		toasts,
	};
};

